import React from 'react';
import { DesktopNavigatorbar } from './DesktopNavigatorbar';
import { MobileNavigatorBar } from './MobileNavigatorBar';
import checkIsMobile from 'utils/CheckIsMobile';

export const NavigationBar = () => {
	return <>{checkIsMobile() ? <MobileNavigatorBar /> : <DesktopNavigatorbar />}</>;
};
